import { tz } from "@date-fns/tz";
import { addDays, format } from "date-fns";
import { formatRange } from "@/client/lib/date-range";
import { leaveCopy } from "@/features/leave/copy";
import { formatHalfDays } from "@/features/leave/half-days";
import type { LeaveHalf } from "@/features/leave/schemas";

const utc = tz("UTC");

/** A leave date has no zone, so it is stepped in UTC and no daylight saving moves it. */
export const dayAfter = (day: string, days = 1): string =>
  format(addDays(day, days, { in: utc }), "yyyy-MM-dd", { in: utc });

/** "Mon 12 to Wed 14 Oct", "Mon 26 Oct to Mon 2 Nov", or one day with its half. */
export function dayRange(
  startsOn: string,
  endsOn: string,
  half: LeaveHalf | null = null,
): string {
  const spelled = formatRange(
    { startsOn, endsOn },
    Number(startsOn.slice(0, 4)),
  );
  return half && startsOn === endsOn
    ? leaveCopy.dates.range.half(spelled, half)
    : spelled;
}

/** "3 days", "1 day", "Half day". */
export const daysLong = (halfDays: number): string =>
  leaveCopy.ask.days(halfDays, formatHalfDays(halfDays));
